import { ArrowLeft } from "@/shared/components/icons";
import { cn } from "@/shared/lib/cn";
import { Link } from "./Link";

interface BackLinkBase {
  label: string;
  className?: string;
  "data-testid"?: string;
}

interface BackLinkAsButton extends BackLinkBase {
  onClick: () => void;
  to?: never;
}

interface BackLinkAsLink extends BackLinkBase {
  to: string;
  onClick?: never;
}

type BackLinkProps = BackLinkAsButton | BackLinkAsLink;

const baseClass = "inline-flex items-center gap-2 text-sm";

export function BackLink({ label, className, "data-testid": testId, ...props }: BackLinkProps) {
  if (props.to) {
    return (
      <Link className={cn(baseClass, className)} data-testid={testId} to={props.to} variant="muted">
        <ArrowLeft className="h-4 w-4" />
        {label}
      </Link>
    );
  }

  return (
    <button
      className={cn(
        "cursor-pointer text-gray-600 transition-colors hover:text-gray-800",
        baseClass,
        className
      )}
      data-testid={testId}
      type="button"
      onClick={props.onClick}
    >
      <ArrowLeft className="h-4 w-4" />
      {label}
    </button>
  );
}
